import { ApiService } from './api.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DataTableParams } from 'angular-datatables-all-versions';
import { Donation } from '../models/jackpot.interface';

import { HttpResponse } from '@angular/common/http';

@Injectable()
export class DonationService {

    constructor(private apiService: ApiService) { }

    list(params: DataTableParams): Observable<any> {
        params.offset = params.offset / params.limit;
        return this.apiService.post('/gandadmin/donations', params);
    }

    quickList(params: DataTableParams): Observable<any> {
        params.offset = params.offset / params.limit;
        return this.apiService.post('/gandadmin/quick_donations', params);
    }

    fetchByUser(id: number, params: DataTableParams): Observable<any> {
        params.offset = params.offset / params.limit;
        return this.apiService.post('/gandadmin/donations/user/' + id, params)
    }

    update(input: Donation): Observable<any>{
        return this.apiService.put('/gandadmin/donations/' + input.id, { charity_donation: input })
    }

    updateAttributes(input: any): Observable<any>{
        return this.apiService.put('/gandadmin/donations/' + input.id, { charity_donation: input })
    }
}
